import { SVGAttributes, memo } from 'react';
import { useV4Theme, getDSColor } from '../theme';
import type { DSColorsKeys } from '../theme';
import { StyledInlineSpinner } from './inline-spinner.styled';

type SpinnerProps = SVGAttributes<SVGSVGElement> & {
  color?: DSColorsKeys;
};

export const InlineSpinner = memo(({ color, ...restProps }: SpinnerProps) => {
  const theme = useV4Theme();
  const fill = color ? getDSColor(theme, color) : 'currentColor';

  return (
    <StyledInlineSpinner
      {...restProps}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.7615 6.18825C15.2949 6.0453 15.8499 6.36188 15.9252 6.909C16.0225 7.61577 16.0251 8.33389 15.9315 9.04419C15.7944 10.0858 15.4535 11.0902 14.9282 12C14.4029 12.9098 13.7036 13.7073 12.8701 14.3468C12.0366 14.9864 11.0853 15.4555 10.0705 15.7274C9.05576 15.9993 7.99736 16.0687 6.95578 15.9315C5.91419 15.7944 4.90981 15.4535 3.99998 14.9282C3.09016 14.4029 2.29271 13.7035 1.65316 12.8701C1.21702 12.3017 0.860146 11.6785 0.591018 11.0178C0.382681 10.5063 0.705038 9.95465 1.2385 9.81171C1.77197 9.66877 2.3129 9.99048 2.54236 10.4928C2.72994 10.9035 2.96372 11.2927 3.23987 11.6525C3.71953 12.2777 4.31762 12.8022 4.99998 13.1961C5.68235 13.5901 6.43564 13.8458 7.21683 13.9486C7.99802 14.0515 8.79182 13.9995 9.5529 13.7955C10.314 13.5916 11.0274 13.2398 11.6526 12.7601C12.2777 12.2804 12.8022 11.6823 13.1961 11C13.5901 10.3176 13.8458 9.56433 13.9487 8.78314C14.0079 8.3334 14.0157 7.87949 13.9729 7.43005C13.9204 6.88026 14.228 6.33119 14.7615 6.18825Z" />
    </StyledInlineSpinner>
  );
});
